import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Container, Form } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { Box } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { ROUTES } from "../../constants/routes";
import LinearProgress from "@material-ui/core/LinearProgress";
// import Login_header from "./Login_header";
// import Login_footer from "./Login_footer";
import { useDispatch, useSelector } from "react-redux";
import * as authAction from "../../reducer-store/actions/authActions";
import { bindActionCreators } from "redux";
import { isRequiredField } from "../../common-components/FormComponent/FormValidator";
import ToastMessage from "../../common-components/ToastMessage";
import { toast } from "react-toastify";
import { OTP_SENT_SUCCESSFULLY } from "../../reducer-store/messages/actionMessages";
import MainComponent from "./MainComponent";

import Logo from "../../common-components/Logo/Logo";
import { styled } from '@mui/material/styles';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const useStyles = makeStyles((theme) => ({
  sectionTop: {
    width: '100%',
    maxWidth: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    // boxShadow: theme.customShadows.card,
    backgroundColor: "#ffffff",
  },
  loginTitle: {
    fontSize: "40px",
    textAlign: "center",
    marginBottom: "70px",
    fontWeight: 700,
    color: "#000000",
    '@media (max-width: 1200px)': {
      fontSize: "32px",
    },
    '@media (max-width: 991px)': {
      fontSize: "30px",
    },
    '@media (max-width: 575px)': {
      fontSize: "22px",
    }
  },
  logoP: {
    position: "fixed",
    '@media (max-width: 768px),(min-width: 480px)': {
      padding: "15px 30px",
    },
    '@media (max-width: 480px)': {
      padding: "15px 10px",
    }
  },
  footer: {
    position: "absolute",
    // right: 0,
    bottom: 0,
    // left: 0,
    backgroundColor: ' #000000',
    width: '100%',
    minHeight: 'auto',
    '@media (max-width: 768px)': {
      position: 'absolute',
      minHeight: 'auto',
      bottom: 0,
    },
  },
  FooterText: {
    textAlign: 'center',
    color: '#ffffff',
    margin: '15px 0px',
    '@media (max-width: 768px)': {
      margin: '15px 0px',
    },
  },
}));

type StateProps = {
  auth: AuthProps;
};

type AuthProps = {
  user: any;
  isAuthenticated: string;
  isVerified: string;
  selectedValue: string;
};

const OnetimePass: React.FC = (props: any) => {
  const classes = useStyles();
  const auth: AuthProps = useSelector((state: StateProps) => state.auth);
  let { user, selectedValue } = auth;
  const dispatch = useDispatch();
  const { sentVerificationOTPCode, updateOtpPlatFormValue } = bindActionCreators(authAction, dispatch);
  const [type, setType] = useState(selectedValue || "email");
  const [isSubmit, setIsSubmit] = useState(false);
  const [isValidValues, setIsValidValues] = useState(true);
  const [loaded, setLoader] = useState(false);
  const history = useHistory();
  let userObj;

  const updateTheOtpPlatform = (value: string) => {
    setType(value);
    updateOtpPlatFormValue(value);
  };

  const SubmitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmit(true);
    if (isRequiredField(type)) {
      setIsSubmit(false);
      setLoader(true);
      if (type === "email") {
        userObj = {
          email: props.history.location.state.email,
        };
      } else {
        userObj = {
          email: props.history.location.state.email,
        };
      }
      let resData: any = await sentVerificationOTPCode(userObj, type);
      if (!resData) {
        setLoader(false);
        return;
      }
      setType("email");
      toast.success(OTP_SENT_SUCCESSFULLY);
      setTimeout(() => {
        setLoader(false);
        history.push({ pathname: ROUTES.addOTP, state: props.history.location.state });
      }, 2000);
    }
    setIsValidValues(false);
  };

  return (
    <>
      {/* <Login_header /> */}
      <MainComponent>
        <StyledRoot>
          <ToastMessage />
          <Box className={classes.logoP}>
            <Link to={ROUTES.login}><Logo size={30} /></Link>
          </Box>

          <section className={classes.sectionTop}>
            <Container className="mt-4">
              <Row className="stap-form">
                <Typography
                  className={classes.loginTitle}
                  variant="h5"
                  component="div"
                >
                  Get Your One Time Password
                </Typography>
              </Row>
              <Row className="stap-form">
                <Col lg="6" sm="12" className=" offset-lg-3">
                  <Box>
                    <Card className="Main_Card" variant="outlined">
                      {loaded && <LinearProgress />}
                      <Form onSubmit={SubmitHandler}>
                        <CardContent></CardContent>
                        <CardContent>
                          <RadioGroup
                            aria-label="type"
                            defaultValue={type}
                            name="radio-buttons-group"
                            className="Radio"
                          >
                            <FormControlLabel
                              name="email"
                              value="email"
                              control={<Radio />}
                              label="Email Id"
                              onChange={(e: any) => updateTheOtpPlatform(e.target.value)}
                            />
                            <FormControlLabel
                              name="phone"
                              value="phone"
                              control={<Radio />}
                              label="Phone Number"
                              onChange={(e: any) => updateTheOtpPlatform(e.target.value)}
                            />
                          </RadioGroup>
                        </CardContent>
                        <CardContent>
                          <div className="logbutton">
                            <div className="text-center">
                              <Link
                                to={ROUTES.login}
                                className="btn btn-style-white"
                              >
                                Back
                              </Link>{" "}
                              <button type="submit" className="btn btn-style">
                                Send
                              </button>
                            </div>
                          </div>
                        </CardContent>
                      </Form>
                    </Card>
                  </Box>
                </Col>
              </Row>
            </Container>
            <footer className={classes.footer}>
              <Container>
                <Row>
                  <Col lg="12" sm="12">
                    <p className={classes.FooterText}>© 2026 Powered By Driving School Cloud.  All rights reserved.</p>
                  </Col>
                </Row>
              </Container>
            </footer>
          </section>
        </StyledRoot>
        {/* <Login_footer /> */}
      </MainComponent>

    </>
  );
};
export default OnetimePass;
